// Global smooth-scroll wrapper using Lenis (same setup the D&D site uses).
//
// Lenis intercepts native scroll and animates it with rAF for a smoother
// feel. position:sticky descendants (sticky bg-scene, sticky headers,
// etc.) continue to work because Lenis drives window scroll position
// directly — it doesn't replace the scroll mechanism with a transform.

import Lenis from 'imports/lenis'

const lenisSmooth = {
    init() {
        // Skip when the user prefers reduced motion.
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)')
        if (reduce && reduce.matches) return

        const lenis = new Lenis({
            // Sensible defaults — easing, lerp/duration tuned a little
            // gentler than Lenis's default for a less floaty feel.
            duration: 1.05,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            // Don't override touch — let mobile keep native momentum.
            smoothTouch: false,
        })

        function raf(time) {
            lenis.raf(time)
            window.requestAnimationFrame(raf)
        }
        window.requestAnimationFrame(raf)

        // Expose for debugging / other modules that want to scrollTo via Lenis.
        window.__lenis = lenis
    },
}

export default lenisSmooth
